/**
 * Labstep
 *
 * @module components/Molecule/DataGrid/coldefs
 * @desc Column definitions for the molecule data grid
 */

import {
  fieldCAS,
  fieldMolecularFormula,
  fieldMolecularWeight,
  fieldName,
} from 'labstep-web/components/PubChemMetadata/Form/fields';
import type { ColGroupDef } from 'labstep-web/core/DataGrid/types';
import type { MetadataParent } from 'labstep-web/models/metadata/types';
import { Molecule } from 'labstep-web/models/molecule.model';
import colDefPubchem from './pubchem';
import colDefSafety from './safety';
import colDefStructure from './structure';
import type { colDefMoleculeParametersType } from './types';

const colDefMolecule = <T extends Molecule | MetadataParent>(
  options?: colDefMoleculeParametersType<T>,
): ColGroupDef<T> => ({
  headerName: Molecule.getHumanReadableEntityName(false, true),
  children: [
    colDefStructure(options),
    colDefPubchem(fieldName, options),
    colDefPubchem(fieldCAS, options),
    colDefPubchem(fieldMolecularFormula, options),
    colDefPubchem(fieldMolecularWeight, options),
    colDefSafety(options),
  ],
});

export default colDefMolecule;
